import { commonTranslationKeys } from '@dreryk/react-common';
import { ModalConfirmButton } from '@dreryk/react-components';

import { HealthcarePracticeBasicData } from '../common/HealthcarePracticeBasicData';
import { HealthcarePracticeFormBean } from '../common/healthcarePractice';

type ServiceProvidingLocationUpdateUsingPracticeDataFormPartProps = {
   readonly healthcarePractice: HealthcarePracticeFormBean;
   readonly onUpdate: () => Promise<void>;
};

export const ServiceProvidingLocationUpdateUsingPracticeDataFormPart = (
   props: ServiceProvidingLocationUpdateUsingPracticeDataFormPartProps
): JSX.Element => {
   return (
      <>
         <HealthcarePracticeBasicData withoutIdentifiers {...props.healthcarePractice} />
         <ModalConfirmButton label={commonTranslationKeys.save} onClick={props.onUpdate} />
      </>
   );
};
